/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc validate関連ユーティリティ
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
import Vue from 'vue'
import StringUtil from '@/utils/StringUtil'
import ChatMessageConst from '@/constants/ChatMessageConst'

export default new class {
  /**
   * 文字列の最大バイト数用validate処理
   * @param  {Object}   rule
   * @param  {String}   value 対象値
   * @param  {String}   receptionMode 対応状態(auto/manual)
   * @param  {Function} callback
   */
  validateWrongPatternSettingList(rule, value, receptionMode, callback) {
    var fcwsWrongPatternSettingList = Vue.prototype.$config.fcwsWrongPatternSettingList
    // AutoReplyでチェックする配列と、manualRy
    for (let fcwsWrongPatternSetting of fcwsWrongPatternSettingList) {
      // 対応中のモード(AutoReply/ManualReply)に合致する入力チェックを実行
      if ((receptionMode === ChatMessageConst.RECEPTION_MODE_AUTO && fcwsWrongPatternSetting.autoReplyValidateFlg === '1') ||
          (receptionMode === ChatMessageConst.RECEPTION_MODE_MANUAL && fcwsWrongPatternSetting.manualReplyValidateFlg === '1')) {
          if (StringUtil.isContainsRegExpPattern(value, fcwsWrongPatternSetting.wrongPattern)) {
            callback(new Error(fcwsWrongPatternSetting.wrongMessage))
            return
          }
      }
    }
    callback()
  }
}()



// WEBPACK FOOTER //
// ./src/utils/ValidateUtil.js